import { apiRequest, handleCall } from 'syft-acp-core/api/call'

import { FetchCsatAgenciesAction } from './actions'

export const fetchCsatAgenciesList = ({ options }: FetchCsatAgenciesAction) =>
  new Promise((resolve, reject) => {
    const request = apiRequest({
      path: `/admin/surveys/agencies/csats`,
      reqArgs: options,
    })
    handleCall(request, resolve, reject, true, options)
  })
